var map = {
	"./logo_alchemy.png": 10736,
	"./logo_coingecko.png": 5426,
	"./logo_coinmarketcap.png": 50527,
	"./logo_defined.png": 26950,
	"./logo_dexscreener.png": 36213,
	"./logo_dexscreener_mark.png": 60707,
	"./logo_dextools_mark.png": 73953,
	"./logo_etherscan.png": 82985,
	"./logo_honeypot.png": 58289,
	"./logo_opensea.png": 18080,
	"./logo_tg.png": 4746,
	"./logo_tokensniffer.png": 32693,
	"./logo_tokensniffer2.png": 86135,
	"./logo_tradingview.png": 8151,
	"./logo_twilio.png": 82082,
	"./logo_twitter.png": 35501,
	"./logo_twitter2.png": 96380,
	"./logo_uniswap.png": 60743,
	"./logo_uniswap2.png": 6516,
	"./logo_x.png": 82280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88443;